import getAllTabbableDescendents from '../getAllTabbableDescendents';
import isKeyboardEvent from '../isKeyboardEvent';
import isElementTabbable from '../isElementTabbable';

var tabbingOutsideOfElement = function tabbingOutsideOfElement(e, element) {
  if (!isKeyboardEvent(e)) {
    return false;
  }

  if (e.key !== 'Tab') {
    return false;
  }

  var tabbableElements = getAllTabbableDescendents(element); // if the element has no tabbable children, a Tab in any direction will lead outside it

  if (!tabbableElements.length) {
    return true;
  }

  if ( // if tabbing forward, we only need to know when tabbing off the last tabbable descendent
  !e.shiftKey && e.target === tabbableElements[tabbableElements.length - 1] || // when tabbing backward, the element itself may or may not be tabbable
  e.shiftKey && (isElementTabbable(element) ? e.target === element : e.target === tabbableElements[0])) {
    return true;
  }

  return false;
};

export default tabbingOutsideOfElement;